import { render, staticRenderFns } from "./AccountSettingNewsletter.vue?vue&type=template&id=bded8b80"
import script from "./AccountSettingNewsletter.vue?vue&type=script&lang=js"
export * from "./AccountSettingNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports